package com.anjuros.website.templates.template10.modules

import com.anjuros.website.templates.template10.util.ResKey

enum class Template10Section(
    val id: String,
    val title: ResKey,
    val path: String
) {
    Benefits(id = "benefits", title = ResKey.TEMPLATE10_SECTION1, path = "#benefits"),
    AboutMe(id = "aboutme", title = ResKey.TEMPLATE10_SECTION2, path = "#aboutme"),
    Videos(id = "videos", title = ResKey.TEMPLATE10_SECTION3, path = "#videos"),
    Timetable(id = "timetable", title = ResKey.TEMPLATE10_SECTION4, path = "#timetable"),
    Contact(id = "contact", title = ResKey.TEMPLATE10_SECTION5, path = "#contact")
}
